import script from "./searchLibrary.vue?vue&type=script&setup=true&lang=js"
export * from "./searchLibrary.vue?vue&type=script&setup=true&lang=js"

import "./searchLibrary.vue?vue&type=style&index=0&id=a0399972&lang=scss"

const __exports__ = script;

export default __exports__